module.exports = __webpack_public_path__ + "img/location-deny.88095611.jpg";